// Copyright (c) 2012-2021 Grab Taxi Holdings PTE LTD (GRAB), All Rights Reserved. NOTICE: All information contained herein
// is, and remains the property of GRAB. The intellectual and technical concepts contained herein are confidential, proprietary
// and controlled by GRAB and may be covered by patents, patents in process, and are protected by trade secret or copyright law.
//
// You are strictly forbidden to copy, download, store (in any medium), transmit, disseminate, adapt or change this material
// in any way unless prior written permission is obtained from GRAB. Access to the source code contained herein is hereby
// forbidden to anyone except current GRAB employees or contractors with binding Confidentiality and Non-disclosure agreements
// explicitly covering such access.
//
// The copyright notice above does not evidence any actual or intended publication or disclosure of this source code,
// which includes information that is confidential and/or proprietary, and is a trade secret, of GRAB.
//
// ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC PERFORMANCE, OR PUBLIC DISPLAY OF OR THROUGH USE OF THIS SOURCE
// CODE WITHOUT THE EXPRESS WRITTEN CONSENT OF GRAB IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE LAWS AND
// INTERNATIONAL TREATIES. THE RECEIPT OR POSSESSION OF THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY
// OR IMPLY ANY RIGHTS TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING
// THAT IT MAY DESCRIBE, IN WHOLE OR IN PART.

import * as Papa from 'papaparse'

export function csvToJSON (file: any, config?: {}) {
  return new Promise((resolve, reject) => {
    Papa.parse(file, {
      config,
      complete: results => {
        if (results.errors.length > 0) {
          return reject(new Error(results.errors.map(x => x.message).join('\n')))
        }
        resolve(results.data)
      }
    })
  })
}

export function jsonToCSV<T> (data: T[]): string {
  const csv = Papa.unparse(data)
  return csv
}

const BOM = '\uFEFF'
export function downloadCSV (csv: string, filename: string) {
  if (navigator.msSaveOrOpenBlob) {
    let blob = new Blob([BOM + csv], { type: 'text/csv;charset=utf-8;' })
    navigator.msSaveOrOpenBlob(blob, filename)
  } else {
    let uri = encodeURI(`data:text/csv;charset=utf-8,${BOM}${csv}`)
    let downloadLink = document.createElement('a')
    downloadLink.href = uri
    downloadLink.download = filename
    document.body.appendChild(downloadLink)
    downloadLink.click()
    document.body.removeChild(downloadLink)
  }
}
